module.exports = __webpack_public_path__ + "img/datawall.ad2cadd2.jpg";